import CheckBox from 'components/CheckBox';
import moment from 'moment';
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, DatePicker, Text } from 'v3/components';
import TextArea from 'v3/components/TextArea';
import { ButtonsContainer, SectionContainer } from '../styles';
import { AddAttachment } from '../AddAttachments';
import { getNextBusinessDay } from '../utils';

export function EndOccurrence({
  description,
  setDescription,
  setShow,
  errors,
  setStartDate,
  setEndDate,
  handleAddEndOccurrenceInfo,
  loadingUpdate,
  setErrors,
  files,
  setFiles,
  nextDeliveryDate,
  setNextDeliveryDate,
  occurrenceTypeSlug,
  selectedOccurrence,
}) {
  useEffect(() => {
    if (
      ['FIRST_DELIVERY_ATTEMPT', 'SECOND_DELIVERY_ATTEMPT'].includes(
        occurrenceTypeSlug
      )
    ) {
      if (selectedOccurrence?.occurrenceClientFields?.nextDeliveryDate) {
        setNextDeliveryDate(
          moment(selectedOccurrence.occurrenceClientFields.nextDeliveryDate).format('DD/MM/YYYY HH:mm')
        );
      } else {
        setNextDeliveryDate(getNextBusinessDay());
      }
    }
  }, [occurrenceTypeSlug]);

  return (
    <>
      <AddAttachment files={files} setFiles={setFiles} loading={loadingUpdate} />
      <SectionContainer>
        <Text type="header" color="dark" weight={500}>
          Concluir Ocorrência
        </Text>
        <TextArea
          placeholder="Adicionar descrição *"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          resizable={false}
          error={errors?.description}
          disabled={loadingUpdate}
        />
        {['FIRST_DELIVERY_ATTEMPT', 'SECOND_DELIVERY_ATTEMPT'].includes(
          occurrenceTypeSlug
        ) && (
          <Row>
            <Col lg={6} md={6} sm={12} xs={12}>
              <DatePicker
                label="Próxima data de entrega *"
                value={nextDeliveryDate}
                onChange={e => setNextDeliveryDate(e.target.value)}
                withTime
                error={errors?.nextDeliveryDate}
                placeholder="01/01/2023 18:00"
                disabled={loadingUpdate}
              />
            </Col>
          </Row>
        )}
        <CheckBox
          label="Ocorrência resolvida"
          defaultChecked
          disabled
          labelStyle={{
            textTransform: 'capitalize',
          }}
        />
        <ButtonsContainer>
          <Button
            variant="secondary"
            onClick={() => {
              setDescription('');
              setStartDate(null);
              setEndDate(null);
              setNextDeliveryDate('');
              setErrors({});
              setShow((old) => ({ ...old, endOccurrence: false }));
            }}
            disabled={loadingUpdate}
          >
            <Text weight={500} color="dark" type="regular">
              CANCELAR
            </Text>
          </Button>
          <Button
            onClick={() => {
              handleAddEndOccurrenceInfo();
            }}
            loading={loadingUpdate}
          >
            <Text weight={500} color="white" type="regular">
              SALVAR
            </Text>
          </Button>
        </ButtonsContainer>
      </SectionContainer>
    </>
  );
}
